export default __webpack_public_path__ + "static/media/87FE5BE0-51BB-4072-B074-AF3755578BB0.1af7d1c6.jpeg";